import { createApp } from "vue";
import { createPinia } from "pinia";
import ui from "@nuxt/ui/vue-plugin";
import "./style.css";
import { initColorMode } from "@/shared/composables/useColorMode";
import { eventBus } from "@/shared/events";
import App from "./App.vue";
import router from "./router";

initColorMode();

eventBus.on("resource:notFound", () => {
  if (router.currentRoute.value.path !== "/404") void router.push("/404");
});

router.onError((error: unknown) => {
  if (
    error instanceof Error &&
    (error.message.includes("Failed to fetch") || error.message.includes("500"))
  ) {
    void router.push({ path: "/404", query: { type: "load-failed" } });
  }
});

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(ui);
app.mount("#app");
